import { render } from "./AllocationTags.vue?vue&type=template&id=228dc5dc&scoped=true"
import script from "./AllocationTags.vue?vue&type=script&lang=js"
export * from "./AllocationTags.vue?vue&type=script&lang=js"

import "./AllocationTags.vue?vue&type=style&index=0&id=228dc5dc&lang=less&scoped=true"

import exportComponent from "/home/gitlab-runner/builds/LUZizzTB/0/unicorn/frontend/unicorn-fe-support/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-228dc5dc"]])

export default __exports__